export function isTest() {
  // @ts-expect-error - Set by Jest
  return process?.env.NODE_ENV === 'test';
}
